<template>
  <section :class="['institution-trial-entry', { 'is-english': isEnglish }]">
    <div class="trial-heading">
      <span class="trial-title">{{ isEnglish ? 'Experience In-Depth Research' : '解锁深度研究' }}</span>
      <router-link class="trial-action" :to="{ name: 'InstitutionApplication', params: { language } }">
        {{ isEnglish ? 'Start Free Trial' : '申请试用' }}
        <img v-if="isEnglish" src="@/assets/research-access/arrow-en.svg" alt="" />
        <img v-else src="@/assets/research-access/arrow.svg" alt="" />
      </router-link>
    </div>
    <p class="trial-description">
      <template v-if="isEnglish">Content available by paid subscription only. Request a trial and our team will reach out. </template>
      <template v-else>本站内容为付费订阅制，暂不支持线上购买。<br />欢迎提交试用申请，商务人员将与您对接。</template>
      <a v-if="detailsUrl" class="trial-details" :href="detailsUrl" target="_blank" rel="noopener noreferrer"><span>{{ isEnglish ? 'Learn more' : '了解详情' }}</span> &gt;</a>
      <span v-else class="trial-details" role="link" aria-disabled="true"><span>{{ isEnglish ? 'Learn more' : '了解详情' }}</span> &gt;</span>
    </p>
  </section>
</template>

<script>
// 中英文试用入口详情页地址。
const TRIAL_DETAILS_URLS = {
  chinese: 'https://www.cf40.com/single/chinese/79',
  english: 'https://www.cf40.com/single/english/80'
};

export default {
  name: 'InstitutionTrialEntry',
  props: {
    language: { type: String, default: 'chinese' }
  },
  computed: {
    isEnglish() { return this.language === 'english'; },
    detailsUrl() { return TRIAL_DETAILS_URLS[this.language] || ''; }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/researchAccess.scss';

.institution-trial-entry {
  box-sizing: border-box;
  width: 100%;
  min-height: 99px;
  padding: 12px 12px 11px 13px;
  color: #ed6f33;
  background: #fdfaf7;
  border: 0.5px solid #ed6f33;
  border-radius: 6px;
  font-family: 'Research Access Chinese', sans-serif;

  .trial-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
  .trial-title { font-size: 20px; line-height: 24px; font-weight: 700; }
  .trial-action {
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    width: 115px;
    height: 28px;
    padding: 0 11px;
    border-radius: 64px;
    color: #fff;
    background: #ff8241;
    font-size: 13px;
    line-height: 19px;
    font-weight: 500;
    white-space: nowrap;
    text-decoration: none;
    img { width: 20.6512px; height: 20.6512px; }
  }
  .trial-description {
    max-width: 291px;
    margin: 10px 0 0;
    color: #5a3118;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
  .trial-details {
    color: #ed6f33;
    font-weight: 700;
    white-space: nowrap;
    text-decoration: none;
    span { text-decoration: underline; text-underline-offset: 2px; }
    &[aria-disabled='true'] { cursor: default; }
  }
  a:focus-visible { outline: 2px solid #a8491c; outline-offset: 3px; }

  &.is-english {
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    .trial-heading {
      box-sizing: border-box;
      min-height: 67px;
      padding: 1px 0 8px;
      flex-direction: column;
      justify-content: flex-start;
      gap: 1px;
      color: #fff;
      background: linear-gradient(90deg, #ed6f33, #ff753a);
      border-radius: 6px;
      font-family: 'Research Access English', Georgia, serif;
    }
    .trial-title { display: flex; align-items: center; justify-content: center; min-height: 35px; font-size: 18px; text-align: center; }
    .trial-action { width: 179px; height: 22px; padding: 0 14px; border: 1px solid #fff; background: transparent; font-weight: 700; }
    .trial-action img { width: 16px; height: 17.3078px; }
    .trial-description { box-sizing: border-box; max-width: none; min-height: 34px; margin-top: 9.5px; padding-top: 3px; line-height: 14px; }
  }
}

@media screen and (max-width: 374px) {
  .institution-trial-entry {
    padding-right: 8px;
    padding-left: 8px;
    .trial-heading { gap: 8px; }
    .trial-title { font-size: 17px; }
    .trial-action { width: 112px; }
    &.is-english { padding: 0; }
    &.is-english .trial-title { font-size: 16px; }
  }
}
</style>
